import React from 'react';
import { observer } from "mobx-react";
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import { OnVoardLogo, OnVoardIcon } from 'components/Svg';
import MenuItem from '../Menu/MenuItem';
import AdminMenuGroup from '../Menu/AdminMenuGroup';
import consoleStore from 'stores/Console/ConsoleStore';
import constants from 'Constants';
import * as paths from 'Paths';
import * as utils from 'Utils';
import './styles.scss';





@observer
class DefaultSidebar extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      activeMenu: "",
    };
  }

  updateActiveMenu = (activeMenu) => {
    if (this.state.activeMenu === activeMenu) {
      this.setState({activeMenu: ""});
      return;
    }

    this.setState({activeMenu: activeMenu});
  };

  render() {
    return (
      <div className="sidebar sidebar-default">
        <div className="sidebar-head">
          <div className="head-icon"><OnVoardIcon /></div>
          <div className="head-title">OnVoard Console</div>
        </div>

        <div className="menu-items">
          <AdminMenuGroup
            activeMenu={this.state.activeMenu}
            updateActiveMenu={this.updateActiveMenu}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}



export { DefaultSidebar };

